<template>
    <div>
        <!-- ========== HEADER ========== -->
        <header id="header" class="u-header">

            <div class="u-header__section">
                <TopBar/>

                <div id="logoAndNav" class="container">
                    <!-- Nav -->
                    <nav class="js-mega-menu navbar navbar-expand-md u-header__navbar u-header__navbar--no-space">
                        <Logo/>
                    </nav>
                    <!-- End Nav -->
                </div>
            </div>
        </header>
        <!-- ========== END HEADER ========== -->

        <router-view></router-view>

        <FooterA/>

        <GoToTop/>
    </div>
</template>

<script>

    import FooterA from "../components/FooterA";
    import GoToTop from "../components/GoToTop";
    import Logo from "../components/Logo";
    import TopBar from "../components/TopBar";

    export default {
        name: "Account",
        components: {TopBar, FooterA, GoToTop, Logo}
    }
</script>

<style scoped>

</style>